import React, { useContext, useState } from "react";
import { Image, View } from "react-native";
import { RouteComponentProps } from "react-router";
import BackButton from "../components/common/BackButton";
import { HeaderTitleSubtitle } from "../components/headerItems/HeaderTitleSubtitle";
import { LargeHeaderIcon } from "../components/headerItems/LargeHeaderIcon";
import { TpIconTeam3 } from "../components/Icon";
import { FullPageWrapper } from "../components/layout/FullPageWrapper";
import { Header } from "../components/layout/Header";
import { APP_PATHS } from "../config";
import OrganizationUserSettings from "../containers/OrganizationUserSettings";
import { RootStoreContext } from "../stores/RootStore";

interface Props extends RouteComponentProps {}

const OrganizationsSettingsUserManagementScreen = ({ history }) => {
  const { organizationStore } = useContext(RootStoreContext);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [currentGroupId, setCurrentGroupId] = useState("");

  let orgLogo;
  if (organizationStore.organization) {
    if (organizationStore.organization.logoUrl128x128) {
      orgLogo = (
        <Image
          style={{ width: 64, height: 64 }}
          source={{
            uri: organizationStore.organization.logoUrl128x128.replace(
              "http:",
              "https:"
            )
          }}
        />
      );
    } else {
      orgLogo = <TpIconTeam3 size={64} />;
    }
  }
  return (
    <FullPageWrapper>
      <Header>
        <BackButton to={APP_PATHS.organization.settings.home} />
        <LargeHeaderIcon>{orgLogo}</LargeHeaderIcon>
        <HeaderTitleSubtitle
          subtitle={
            organizationStore.organization
              ? organizationStore.organization.name
              : " "
          }
          title="Användarhantering"
        />
        {/* <HeaderMenuButton /> */}
      </Header>
      <View style={{ padding: 15 }}>
        <OrganizationUserSettings
          doneAction={() => history.push(APP_PATHS.organization.settings.home)}
        />
      </View>
    </FullPageWrapper>
  );
};

export default OrganizationsSettingsUserManagementScreen;
